let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a0epF")).then(() => parcelRequire('fNV4p'));